/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchEventCategoriesResponseCategories,
  FetchEventCategoriesResponseCategoriesFromJSON,
  FetchEventCategoriesResponseCategoriesToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchEventCategoriesResponse
 */
export interface FetchEventCategoriesResponse {
  /**
   *
   * @type {Array<FetchEventCategoriesResponseCategories>}
   * @memberof FetchEventCategoriesResponse
   */
  categories?: Array<FetchEventCategoriesResponseCategories>
}

export function FetchEventCategoriesResponseFromJSON(
  json: any
): FetchEventCategoriesResponse {
  return FetchEventCategoriesResponseFromJSONTyped(json, false)
}

export function FetchEventCategoriesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchEventCategoriesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    categories: !exists(json, 'categories')
      ? undefined
      : (json['categories'] as Array<any>).map(
          FetchEventCategoriesResponseCategoriesFromJSON
        ),
  }
}

export function FetchEventCategoriesResponseToJSON(
  value?: FetchEventCategoriesResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    categories:
      value.categories === undefined
        ? undefined
        : (value.categories as Array<any>).map(
            FetchEventCategoriesResponseCategoriesToJSON
          ),
  }
}
